import immutable from 'immutable'
import Guid from 'guid'
import _ from 'lodash'

import legUtil from '../util/leg.util'

import {
    PREPEND_DAY,
    APPEND_DAY,
    REMOVE_DAY,
    UPDATE_DESTINATION,
} from '../planner/planner.action'

import {
    ADD_LEG,
    MOVE_LEGS,
    RESIZE_LEGS,
    DELETE_LEG,
    ADD_ACCOMMODATION,
    ADD_DESTINATION_ACCOMMODATION,
    UPDATE_ACCOMMODATION_RESERVATION,
    REMOVE_ACCOMMODATION,
    ADD_ACTIVITY,
    ADD_DESTINATION_ACTIVITY,
    UPDATE_ACTIVITY_RESERVATION,
    REMOVE_ACTIVITY,
} from './leg.action'


export default (state, action) => {
    switch (action.type) {
        case ADD_LEG:
            return state.push(action.leg)
        case MOVE_LEGS:
            _.each(action.legs, (moveAction) => {
                let moveLegIndex = state.findIndex((leg) => {
                    return leg.get('id') === moveAction.leg.get('id')
                })

                state = state.update(moveLegIndex, (leg) => {
                    const diff = moveAction.start - leg.getIn(['properties', 'start'])

                    return leg.mergeIn(['properties'], {
                        start: moveAction.start,
                        end: leg.getIn(['properties', 'end']) + diff
                    })
                })
            })

            return state
        case RESIZE_LEGS:
            _.each(action.legs, (resizeAction) => {
                let resizeLegIndex = state.findIndex((leg) => {
                    return leg.get('id') === resizeAction.leg.get('id')
                })

                state = state.update(resizeLegIndex, (leg) => {
                    return leg.mergeIn(['properties'], {
                        start: resizeAction.start,
                        end: resizeAction.end,
                        length: resizeAction.end - resizeAction.start
                    })
                })
            })

            return state
        case UPDATE_DESTINATION:
            let destLegIndex = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })

            return state.update(destLegIndex, (leg) => {
                let newDest = legUtil.formatDestination(action.destination)
                return leg.mergeIn(['destination'], newDest)
            })
        case DELETE_LEG:
            let deleteIdx = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })
            return state.delete(deleteIdx)
        case PREPEND_DAY:
            console.log('in here – i got called because of the prepend!')
            return state.map((leg) => {
                return leg.mergeIn(['properties'], {
                    start: leg.getIn(['properties', 'start']) + 1,
                    end: leg.getIn(['properties', 'end']) + 1
                })
                // return leg.updateIn(['properties', 'start'], start => start + 1)
            })
        case REMOVE_DAY:
            // find all legs after the removed day and shift them 1 day left
            return state.map((leg) => {
                if (leg.getIn(['properties', 'start']) >= action.index) {
                    return leg.mergeIn(['properties'], {
                        start: leg.getIn(['properties', 'start']) - 1,
                        end: leg.getIn(['properties', 'end']) - 1
                    })
                    // return leg.updateIn(['properties', 'start'], start => start - 1)
                }

                return leg
            })
        case ADD_ACCOMMODATION:
            let targetLegIdx = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })

            state = state.update(targetLegIdx, (leg) => {
                return leg.update('accommodations', (accommodations) => {
                    let accObj = legUtil.formatAccommodation(action.accommodation, action.user)
                    // accom is converted to immutable before being added but we need to add the user and a unique id
                    // let newAcc = action.accommodation.merge({'added_by': action.user.firstname,'accommodation_guid': Guid.raw()});
                    return accommodations.push(new immutable.fromJS(accObj))
                })
            })
            return state
        case ADD_DESTINATION_ACCOMMODATION:
            let tLegIdx = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })
            // update destination
            state = state.update(tLegIdx, (leg) => {
                let newDest = legUtil.formatDestination(action.destination)
                return leg.mergeIn(['destination'], newDest)
            })

            // update accom
            state = state.update(tLegIdx, (leg) => {
                return leg.update('accommodations', (accommodations) => {
                    let newAccom = legUtil.formatAccommodation(action.accommodation, action.user)
                    return accommodations.push(new immutable.fromJS(newAccom))
                })
            })

            return state
        case UPDATE_ACCOMMODATION_RESERVATION:
            let updateLegIdx = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })

            state = state.update(updateLegIdx, (leg) => {
                return leg.update('accommodations', (accommodations) => {
                    let targetAccomIdx = accommodations.findIndex((accomm) => {
                        return accomm.get('accommodation_guid') === action.accommodation.get('accommodation_guid')
                    })
                    return accommodations.update(targetAccomIdx, (accomm) => {
                        return accomm.mergeIn(['reservation_details'], action.accommodation.get('reservation_details'))
                    })
                })
            })

            return state
        case REMOVE_ACCOMMODATION:
            let delAccommLegIdx = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })

            state = state.update(delAccommLegIdx, (leg) => {
                return leg.update('accommodations', (accommodations) => {
                    let deleteIdx = accommodations.findIndex((accomm) => {
                        return accomm.get('id') === action.accommodation.get('id')
                    })
                    return accommodations.delete(deleteIdx)
                })
            })
            return state
        case ADD_ACTIVITY:
            let activityLegIdx = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })

            state = state.update(activityLegIdx, (leg) => {
                return leg.update('activities', (activities) => {
                    let actObj = legUtil.formatActivity(action.activity, action.user)
                    return activities.push(new immutable.fromJS(actObj))
                })
            })
            return state
        case ADD_DESTINATION_ACTIVITY:
            let tActLegIdx = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })
            // update destination
            state = state.update(tActLegIdx, (leg) => {
                let newDest = legUtil.formatDestination(action.destination)
                return leg.mergeIn(['destination'], newDest)
            })
            // update accom
            state = state.update(tActLegIdx, (leg) => {
                return leg.update('activities', (activities) => {
                    let newAct = legUtil.formatActivity(action.activity, action.user)
                    return activities.push(new immutable.fromJS(newAct))
                })
            })

            return state
        case UPDATE_ACTIVITY_RESERVATION:
            let updateActLegIdx = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })
            return state.update(updateActLegIdx, (leg) => {
                return leg.update('activities', (activities) => {
                    let targetActIdx = activities.findIndex((act) => {
                        return act.get('activity_guid') === action.activity.get('activity_guid')
                    })
                    return activities.update(targetActIdx, (act) => {
                        return act.mergeIn(['reservation_details'], action.activity.get('reservation_details'))
                    })
                })
            })
        case REMOVE_ACTIVITY:
            let delActivityLegIdx = state.findIndex((leg) => {
                return leg.get('id') === action.leg.get('id')
            })

            state = state.update(delActivityLegIdx, (leg) => {
                return leg.update('activities', (activities) => {
                    let deleteIdx = activities.findIndex((activity) => {
                        return activity.get('activity_guid') === action.activity.get('activity_guid')
                    })
                    return activities.delete(deleteIdx)
                })
            })
            return state
        default:
            return state
    }
}
